import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      featureFlags: 'features/featureFlags',
    }),
    selfServiceFeatureFlags() {
      return this.featureFlags.selfService
    },
  },
}
